
import styles from "./Pnc.module.scss";
function Pnp() {
    return (
      <div>
        <iframe
          src="https://dzld1wiuvhv8i.cloudfront.net/privacy-policy.html"
          title="Privacy Policy"
          style={{ width: "100%", height: "100vh", border: "none" }}
        ></iframe>
      </div>
    );
  }
  
  export default Pnp;
  